module.exports = __webpack_public_path__ + "static/img/hyzz1.7a4759f9.png";